import React, { useState } from "react";
import "./DeletePropertyModal.css";
import { toast } from "react-toastify";


const DeletePropertyModal = ({ listing, onClose, onDelete }) => {
  const [deleteReason, setDeleteReason] = useState("");

  const handleReasonChange = (event) => {
    setDeleteReason(event.target.value);
  };

  const handleConfirmDelete = () => {
    if (!deleteReason) {
      toast.error("Please select a reason for deletion.");
      return;
    }
    onDelete(listing.id, deleteReason); // Pass the reason to the delete handler
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Delete Property</h2>
        <p>Why do you want to delete this property?</p>

        <div className="reasons">
          <label>
            <input
              type="radio"
              value="sold by me"
              checked={deleteReason === "sold by me"}
              onChange={handleReasonChange}
            />
            Sold by me
          </label>
          <label>
            <input
              type="radio"
              value="sold by someone else"
              checked={deleteReason === "sold by someone else"}
              onChange={handleReasonChange}
            />
            Sold by someone else
          </label>
          <label>
            <input
              type="radio"
              value="outdated"
              checked={deleteReason === "outdated"}
              onChange={handleReasonChange}
            />
            Outdated
          </label>
        </div>

        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-button" onClick={handleConfirmDelete}>
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePropertyModal;
